export enum CollectionNames {
  Profiles = "profiles",
  Jobs = "jobs",
  Brands = "brands",
  Events = "events",
  ProfileJobJunction = "profile_job_junction",
}

export enum SubCollectionNames {
  Categories = "categories",
}
